import { ArrowUpLeft, Check, Smartphone } from 'lucide-react';
import { ANDROID_STORES } from '../../storeLinks.js';
import { IphoneWebAppButton } from '../WebAppCta';

const CTA = () => (
    <section id="download" className="download-section">
        <div className="site-container download-card">
            <div className="download-logo"><img src="/hooshpaz-logo.webp" alt="نشان هوش‌پز" /></div>
            <div className="download-copy">
                <span>امشب چی بپزم؟</span>
                <h2>جوابش همین حالا داخل آشپزخانه توست.</h2>
                <p>هوش‌پز را نصب کن یا بدون نصب در مرورگر بازش کن و با موادی که همین حالا داری، اولین دستور پختت را بساز.</p>
                <div className="download-points"><span><Check size={17} /> اندروید و نسخه وب برای آیفون</span><span><Check size={17} /> رابط کاملاً فارسی</span></div>
            </div>
            <div className="store-actions">
                <div className="store-row">
                    {ANDROID_STORES.map((store) => (
                        <a key={store.id} className="store-button" href={store.url} target="_blank" rel="noreferrer">
                            <Smartphone size={26} aria-hidden="true" /><span><small>دریافت از</small><b>{store.name}</b></span><ArrowUpLeft size={20} aria-hidden="true" />
                        </a>
                    ))}
                </div>
                <IphoneWebAppButton />
            </div>
        </div>
    </section>
);

export default CTA;
